import React, { useEffect, useMemo, useState } from 'react';
import styles from './Chats.module.scss';
import MoreButton from 'component/atom/moreButton/MoreButton';
import PopOver from 'component/atom/moreButton/popOver/PopOver';
import RenameChatTitle from '../rename-chat-title/RenameChatTitle';
import ConfirmationModal from 'component/hoc/success-modal/ConfirmationModal';
import { chatEndpoints } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
const safeDecode = (val) => {
  if (val == null) return '';
  try {
    return decodeURIComponent(String(val));
  } catch {
    return String(val);
  }
};

const RTL_REGEX =
  /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
const computeDir = (s) => (RTL_REGEX.test(s) ? 'rtl' : 'ltr');
const computeLang = (s) => (RTL_REGEX.test(s) ? 'ar' : 'en');
export const ChatItem = ({
  id,
  text,
  isActive,
  onClick,
  refetchChatsList,
  setLastChatSelection,
}) => {
  const [isRenameChatTitle, setIsRenameChatTitle] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const { mutate: deleteChat, isPending: isPendingDelete } = usePost();

  const popOverItems = [
    {
      title: 'Rename',
      handleFunction: (e) => (e.stopPropagation(), setIsRenameChatTitle(true)),
      icon: 'edit_table',
    },
    {
      title: 'Delete',
      handleFunction: (e) => (e.stopPropagation(), setIsDeleteModalOpen(true)),
      icon: 'delete_table',
      color: 'red',
    },
  ];
  const titleText = useMemo(() => {
    const t = safeDecode(text).trim();
    return t || 'Untitled chat';
  }, [text]);

  const dir = useMemo(() => computeDir(titleText), [titleText]);
  const lang = useMemo(() => computeLang(titleText), [titleText]);
  const handleDelete = () => {
    deleteChat(
      {
        method: 'Delete',
        url: chatEndpoints?.deleteChat(id),
      },
      {
        onSuccess: async () => {
          setIsDeleteModalOpen(false);

          const res = await refetchChatsList();
          const nextList = res?.data?.data || [];

          if (isActive) {
            setLastChatSelection(nextList);
          }
        },
      },
    );
  };

  return (
    <>
      <div
        className={`${styles['item']} ${isActive ? styles['active'] : ''}`}
        onClick={() => onClick(id)}
      >
        <div
          className={`${styles['chat-title']}  ${
            isActive ? styles['active-title'] : ''
          }`}
        >
          <p
            className={styles['title-text']}
            dir={dir}
            lang={lang}
            title={titleText}
          >
            <bdi>{titleText}</bdi>
          </p>
        </div>
        {!isDeleteModalOpen && !isRenameChatTitle && (
          <div
            className={`${styles['actions']} ${
              isActive ? styles['active-action'] : ''
            }`}
          >
            <MoreButton icon='three_dots' toolTipText='More'>
              <PopOver stop info={popOverItems} />
            </MoreButton>
          </div>
        )}
        {isRenameChatTitle && (
          <RenameChatTitle
            isOpen={isRenameChatTitle}
            onClose={() => setIsRenameChatTitle(false)}
            id={id}
            title={decodeURIComponent(text)}
            refetch={refetchChatsList}
            // setRefetch={() => setRefetch((prev) => !prev)}
          />
        )}
        <ConfirmationModal
          isOpen={isDeleteModalOpen}
          onClose={() => setIsDeleteModalOpen(false)}
          onSubmit={handleDelete}
          // closeOnSubmit={true}
          onApproveButton={{ text: 'delete' }}
          text='Delete Chat'
          subText='Are you sure you want to delete this chat? 
This action cannot be undone.'
          isLoading={isPendingDelete}
          subTextClassName={styles.modalSubText}
          modalContentClassName={styles.modalContentClassName}
          buttonClassName={styles.buttonClassName}
          closeBtnContainerClassName={styles.closeBtnContainer}
          closeBtnClassName={styles.closeBtn}
        />
      </div>
    </>
  );
};

const Chats = ({
  isExpanded,
  data,
  getActiveChat,
  currentChat,
  refetchChatsList,
  setLastChatSelection,
}) => {
  const [activeItem, setActiveItem] = useState(currentChat);
  const setActive = (id) => {
    setActiveItem(id);
    getActiveChat(id);
  };
  useEffect(() => {
    setActiveItem(currentChat);
  }, [currentChat]);

  return (
    <div
      className={`${styles['chats-container']} ${
        isExpanded ? styles['expended'] : ''
      }`}
    >
      <div className={styles['chat-header']}>
        <p>Chats</p>
      </div>
      <div className={styles['chats-items']}>
        {data?.flatMap((item, index) => (
          <ChatItem
            key={index}
            id={item.chatId}
            text={item.chatTitle}
            isActive={activeItem === item.chatId}
            onClick={() => setActive(item.chatId)}
            refetchChatsList={refetchChatsList}
            setLastChatSelection={setLastChatSelection}
          />
        ))}
      </div>
    </div>
  );
};

export default Chats;
